import { RootState } from 'types/state'
import { settingsSelectors } from 'store/settings'

// The runtime inputs the host injected, narrowed to what the agents declared.
// Re-sent on every agent call (answer + confirm) so secrets are never persisted server-side.
export const buildAgentInputs = (state: RootState): Record<string, unknown> => {
  const requirements = settingsSelectors.agentInputRequirements(state)
  const all = settingsSelectors.agentInputs(state)
  return requirements.reduce<Record<string, unknown>>((acc, { key }) => {
    if (all[key] !== undefined) acc[key] = all[key]
    return acc
  }, {})
}
